"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toast = void 0;
var _react = _interopRequireDefault(require("react"));
var _box = require("@oneloop/box");
var _icons = require("@oneloop/icons");
var _text = require("@oneloop/text");
var _button = require("@oneloop/button");
var _loader = require("@oneloop/loader");
var _excluded = ["variant", "variantLoader", "variantText", "icon", "text", "subtitle", "closeIconNeighbor", "textDownload", "download", "hideCloseIcon"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var Toast = exports.Toast = function Toast(_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'base' : _ref$variant,
    variantLoader = _ref.variantLoader,
    _ref$variantText = _ref.variantText,
    variantText = _ref$variantText === void 0 ? 'body.fontSize14' : _ref$variantText,
    icon = _ref.icon,
    text = _ref.text,
    subtitle = _ref.subtitle,
    closeIconNeighbor = _ref.closeIconNeighbor,
    textDownload = _ref.textDownload,
    download = _ref.download,
    _ref$hideCloseIcon = _ref.hideCloseIcon,
    hideCloseIcon = _ref$hideCloseIcon === void 0 ? false : _ref$hideCloseIcon,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_box.Flex, _extends({
    tx: "toast",
    variant: variant
  }, props, {
    __css: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      padding: '0px 24px 0px 0px',
      gap: '24px',
      position: 'relative',
      height: '72px',
      background: '#272E33',
      borderRadius: '6px',
      color: 'white',
      width: closeIconNeighbor ? '577px' : '423px',
      justifyContent: closeIconNeighbor ? 'space-between' : 'unset'
    }
  }), /*#__PURE__*/_react["default"].createElement(_box.Box, {
    __css: {
      width: '327px',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      padding: '0px',
      gap: '16px',
      marginLeft: '24px'
    }
  }, icon !== undefined && /*#__PURE__*/_react["default"].createElement(_icons.Icon, {
    icon: icon,
    fontSize: "32px"
  }), variantLoader !== undefined && /*#__PURE__*/_react["default"].createElement(_loader.Loader, {
    variant: variantLoader,
    style: {
      width: '32px',
      height: '32px'
    }
  }), text !== undefined && subtitle !== undefined && /*#__PURE__*/_react["default"].createElement(_box.Box, {
    __css: {
      display: 'flex',
      flexDirection: 'column',
      gap: 2
    }
  }, /*#__PURE__*/_react["default"].createElement(_text.Text, {
    variant: variantText,
    color: "white",
    fontWeight: "700",
    fontSize: "14px"
  }, text), /*#__PURE__*/_react["default"].createElement(_text.Text, {
    color: "white",
    fontSize: "14px"
  }, subtitle)), text !== undefined && subtitle === undefined && /*#__PURE__*/_react["default"].createElement(_text.Text, {
    variant: variantText,
    display: "flex",
    alignItems: "center",
    color: "white"
  }, text), download !== undefined && /*#__PURE__*/_react["default"].createElement(_button.ButtonIcon, {
    icon: "icon-descargar",
    variant: "mainItemSmall",
    color: "white",
    text: textDownload,
    onClick: download
  })), !hideCloseIcon && !closeIconNeighbor && /*#__PURE__*/_react["default"].createElement(_button.ButtonIcon, {
    color: "white",
    icon: "icon-cerrar",
    variant: ['subtleTrasnparentIconClearButton', 'iconMedium'],
    onClick: function onClick() {
      return props.closeFunction();
    }
  }), !hideCloseIcon && closeIconNeighbor && /*#__PURE__*/_react["default"].createElement(_box.Box, {
    __css: {
      alignItems: 'center',
      display: 'flex',
      gap: 4
    }
  }, closeIconNeighbor, /*#__PURE__*/_react["default"].createElement(_button.ButtonIcon, {
    color: "white",
    icon: "icon-cerrar",
    variant: ['subtleTrasnparentIconClearButton', 'iconMedium'],
    onClick: function onClick() {
      return props.closeFunction();
    }
  })));
};